import { createActions } from "redux-actions";

export default createActions({
  TOP: {
    MYCIRCLES: {
      SET: () => ({}),
      SUCCESS: (data) => ({
        data,
      }),
      FAILURE: (error) => ({
        error,
      }),
    },
  },
});
